import {
  Alert,
  AlertIcon,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { formatBRL } from "../../utils/currency";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  titulo: string;
  descricao: string | string[];
  confirmLabel?: string;
  multa?: number;
  exibirMulta?: boolean;
  multaNaFatura?: boolean;
};

export function ModalConfirmarDevolucao({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  titulo,
  descricao,
  confirmLabel = "Sim",
  multa = 0,
  exibirMulta = false,
  multaNaFatura = false,
}: Props) {
  const multaValida = Number.isFinite(multa) && multa > 0;
  const deveExibirAvisoTaxa = exibirMulta;
  const textoBotao = exibirMulta && multaValida
    ? multaNaFatura
      ? `${confirmLabel} com taxa retida por bilhete de ${formatBRL(multa)}`
      : `${confirmLabel} com taxa por bilhete de ${formatBRL(multa)}`
    : confirmLabel;

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent borderRadius="8px">
        <ModalHeader>{titulo}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {!deveExibirAvisoTaxa && (
            Array.isArray(descricao) ? (
              descricao.map((linha) => (
                <Text key={linha}>{linha}</Text>
              ))
            ) : (
              <Text>{descricao}</Text>
            )
          )}
          {deveExibirAvisoTaxa && (
            <Alert status="warning" mt={4} borderRadius="8px">
              <AlertIcon />
              <Text>
                Esta devolução tem uma taxa de cancelamento, definido pela viação.
                <br />
                Após a devolução verifique a conta corrente para confirmar o valor.
                {multaValida && (
                  <>
                    <br />
                    Taxa de cancelamento retida por bilhete: {formatBRL(multa)}.
                  </>
                )}
              </Text>
            </Alert>
          )}
        </ModalBody>
        <ModalFooter gap={3}>
          <Button variant="outline" onClick={onClose} isDisabled={isLoading}>
            Não
          </Button>
          <Button colorScheme="red" onClick={onConfirm} isLoading={isLoading} whiteSpace="normal">
            {textoBotao}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
